export const getViaIndexed = (length) =>
  Array.from({ length }, (v, i) => i).slice(1, length - 1);
